__turbopack_context__.v({
  "attributesContainer": "M799tW_attributesContainer",
  "brandName": "M799tW_brandName",
});
